import { render, staticRenderFns } from "./mindsets_page.vue?vue&type=template&id=dd35a1c4&scoped=true"
import script from "./mindsets_page.vue?vue&type=script&lang=js"
export * from "./mindsets_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd35a1c4",
  null
  
)

export default component.exports